/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AppointmentAttachmentResponse = {
    fileId: string;
    type: AppointmentAttachmentResponse.type;
    name: string;
    createdAt: string;
};

export namespace AppointmentAttachmentResponse {

    export enum type {
        AUDIO = 'AUDIO',
        TRANSCRIPT = 'TRANSCRIPT',
        SUMMARY = 'SUMMARY',
    }


}

